import React from 'react';
import { Result, Button } from 'antd';

const ErrorPage = props => {
    return (
        <div>
            <Result
                status="warning"
                title="Se produjo un error."
                extra={
                <Button type="primary" key="console">
                    <a href="/">Inicio</a>
                </Button>
                }
            />
        </div>
    );
};

ErrorPage.propTypes = {
    
};

export default ErrorPage;